// extracted by mini-css-extract-plugin
module.exports = {"container":"SingleArticle_container__2OXxO","article":"SingleArticle_article__1dea7","articleText":"SingleArticle_articleText__3JPDB"};